import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const Testimonials = () => {
  const testimonials = [
    {
      name: "Mr. Amol Gavhane",
      company: "Corporate Client",
      feedback:
        "We are extremely satisfied with Pune Corporate Cars India Pvt. Ltd. Vehicles are clean, punctual, and well-maintained. Their drivers and operations team handle even urgent requirements seamlessly.",
    },
    {
      name: "Miss. Hima Pradhan",
      company: "Corporate Client",
      feedback:
        "Pune Corporate Cars India Pvt. Ltd. has proven to be a highly dependable transportation partner. Clean vehicles, disciplined drivers, and well-coordinated operations make them an excellent choice for corporate travel.",
    },
    {
      name: "Mr. Ali Sayyad",
      company: "Business Client",
      feedback:
        "Pune’s best tech-enabled corporate car rental service with GPS tracking, online booking, digital invoicing, and real-time trip monitoring.",
    },
    {
      name: "Mr. Prashant Savalkar",
      company: "Corporate Client",
      feedback:
        "Outstanding service with on-time arrival, well-maintained vehicles, and courteous drivers. The entire experience was smooth and professional.",
    },
      {
    name: "Mr. Kalpesh Rajole",
    company: "Verified Client",
    logo: "/images/logos/google.png",
    feedback:
      "Had a great experience with Pune Corporate Cars Pvt. Ltd. The car was spotless, arrived on time, and the driver was extremely courteous. Booking was smooth and hassle-free. Will definitely choose them again.",
    color: "#2E86C1",
  },
  {
    name: "Mr. Aditya Bhise",
    company: "Corporate Client",
    logo: "/images/logos/google.png",
    feedback:
      "If you’re looking for reliable and top-notch corporate car rental services in Pune, Pune Corporate Cars India Private Limited is the best. Professional chauffeurs, well-maintained fleet, and excellent customer support.",
    color: "#1B4F72",
  },
  {
    name: "Miss. Sakshi Nanvare",
    company: "Corporate Client",
    logo: "/images/logos/google.png",
    feedback:
      "Excellent service quality with uniformed drivers, good driving skills, clean cars, polite language, and thoughtful amenities like water bottles and tissues. Very happy with the service.",
    color: "#154360",
  },
  {
    name: "Mr. Mayur Shinde",
    company: "Corporate Client",
    logo: "/images/logos/google.png",
    feedback:
      "Great experience with Pune Corporate Cars. The service was punctual, vehicles were clean, and the driver was professional and courteous. Highly recommended for corporate travel needs in Pune.",
    color: "#0E3C6E",
  },
  {
    name: "Mr. Malum Nahi",
    company: "Corporate Client",
    logo: "/images/logos/google.png",
    feedback:
      "Excellent corporate car rental experience. Clean and comfortable cars, punctual and professional drivers, and impressive coordination even in last-minute situations. Highly recommended for businesses.",
    color: "#1A5276",
  },
  {
    name: "Miss. Hima Pradhan",
    company: "Enterprise Client",
    logo: "/images/logos/google.png",
    feedback:
      "Timely operations, customer-focused service, and disciplined drivers make Pune Corporate Cars India Pvt. Ltd. a trusted partner for corporate mobility. Their service quality truly stands out.",
    color: "#21618C",
  },
  {
    name: "Mr. Amol Gavhane",
    company: "Business Client",
    logo: "/images/logos/google.png",
    feedback:
      "Professional drivers, excellent coordination, and flexibility in handling schedule changes have made Pune Corporate Cars an invaluable partner for our corporate transportation needs.",
    color: "#2874A6",
  },
  ];

  return (
    <section className="testimonials-section pt120 pb_0 grey-bg">
      <div className="container">
        <div className="section-title centred mb_60">
          <span className="sub-title">Testimonials</span>
          <h2 className="title">What our Clients Say</h2>
        </div>

     <Swiper
  modules={[Autoplay, Pagination]}
  slidesPerView={1}
  spaceBetween={0}
  autoplay={{
    delay: 5000,
    disableOnInteraction: false,
  }}
  pagination={{ clickable: true }}
  style={{ overflow: "hidden" }}
>
  {testimonials.map((item, index) => (
    <SwiperSlide key={index}>
      <div className="testimonial-slide">
        <div className="testimonial-block-one style-two">
          <h5>{item.name}</h5>
          <span className="designation">{item.company}</span>

          <ul className="author-rating">
            {[...Array(5)].map((_, i) => (
              <li key={i}>
                <i className="icon-21"></i>
              </li>
            ))}
          </ul>

          <p>{item.feedback}</p>
        </div>
      </div>
    </SwiperSlide>
  ))}
</Swiper>

      </div>
    </section>
  );
};

export default Testimonials;
